export interface ComparisonRow {
  dimension: string;
  zenfresh: string;
  traditionalMarket: string;
}

// Deliberately generic "a traditional fish market" framing throughout — no
// named competitor, business, or brand, per this ticket's own AC.
export const COMPARISON_ROWS: ComparisonRow[] = [
  {
    dimension: "Freshness Verification",
    zenfresh: "Catch-to-delivery time shown per order, with a freshness score.",
    traditionalMarket: "No record of when the catch actually happened.",
  },
  {
    dimension: "Hygiene",
    zenfresh: "Cold-chain packed and temperature-logged from dock to door.",
    traditionalMarket: "Ambient handling and transport, hygiene varies by stall.",
  },
  {
    dimension: "Price Transparency",
    zenfresh: "Price shown upfront, same for every buyer.",
    traditionalMarket: "Prices often negotiated per customer, per visit.",
  },
  {
    dimension: "Delivery Convenience",
    zenfresh: "Ordered from home, delivered same day.",
    traditionalMarket: "Requires an in-person visit, usually early morning.",
  },
  {
    dimension: "Sourcing Traceability",
    zenfresh: "Every order links back to the boat and catch date.",
    traditionalMarket: "Origin is rarely tracked past the wholesaler.",
  },
];
